<template>
  <section :class="[{center:centered}, 'ContentSection']">
    <h2>{{ title }}</h2>
    <div class="content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    title: {
      type: String
    },
    centered: {
      type: Boolean,
      default: false
      // default: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    toggleQuote() {
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss" scoped>
.ContentSection {
  @include siteWrapper;
  margin: 50px auto;

  &:last-child {
    margin: 50px auto 0 auto;
  }

  & h2 {
    font-size: 40px;
    margin: 0 0 30px 0;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #000;
  }

  & .content {
    margin-left: auto;
    width: 900px;

    & h3 {
      @include fontBodyHead;
      font-size: 22px;
      line-height: 32px;
      margin: 40px 0 5px 0;

      &:first-child {
        margin: 0 0 5px 0;
      }
    }

    & p {
      margin: 0 0 30px 0;

      &:last-child {
        margin: 0;
      }
    }

    ol {
      list-style: none;
      counter-reset: step-counter;
      margin: 0;
      padding: 0;
    }
    ol>li {
      counter-increment: step-counter;
      padding: 0 0 30px 40px;
      position: relative;

      & h3 {
        margin: 0 0 20px 0 !important;
      }
    }
    ol>li::before {
      content: "0" counter(step-counter) ".";
      @include fontBodyHead;
      // color: $greyMed;
      color: #b2b2b2;
      font-size: 22px;
      line-height: 32px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  @media screen and (max-width: 1200px) {
    & .content {
      width: 75%;
    }
  }
  @media screen and (max-width: $breakLarge) {
    & h2 {
      font-size: 36px;
      text-align: center;
      padding: 0 0 20px 0;
    }

    & .content {
      margin-left: 0;
      width: 100%;
    }
  }
  @media screen and (max-width: $breakSmall) {
    width: calc(100% - 40px);
  }
  // centered version
  &.center {
    margin: 120px auto 0 auto;

    & h2 {
      // font-size: 36px;
      text-align: center;
      padding: 0 0 20px 0;
    }

    & .content {
      margin: 0 auto;
      width: 900px;
      
      & p {
        text-align: center;
      }
    }
    @media screen and (max-width: $breakLarge) {
      margin: 90px auto 0 auto;

      & .content {
        width: 100%;
      }
    }
    @media screen and (max-width: $breakSmall) {
      margin: 80px auto 0 auto;
    }
  }
}

</style>
